import React from 'react';

export const AppSettings = React.createContext();
//export const externalAddress = 'http://127.0.0.1:80'; //local
//export const botspotAddress = 'http://localhost:3000'; //local
export const externalAddress = 'https://botspot.com.br'; //prod
export const botspotAddress = 'https://botspot.com.br'; //prod